import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';

export default function AddedPackagingBadge(): React.JSX.Element {
  const { t } = useTranslation(['products']);

  return (
    <Chip
      variant="tag"
      icon={<AddBoxOutlinedIcon />}
      label={t('base_unit_added')}
      color="primaryContainer"
    />
  );
}
